(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin/rich-text/assets/javascripts/viewer.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin/rich-text/assets/javascripts/viewer.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _Lexical = Lexical,
  LexicalComposer = _Lexical.LexicalComposer,
  ContentEditable = _Lexical.ContentEditable,
  RichTextPlugin = _Lexical.RichTextPlugin,
  ListPlugin = _Lexical.ListPlugin,
  LexicalErrorBoundary = _Lexical.LexicalErrorBoundary,
  ListNode = _Lexical.ListNode,
  ListItemNode = _Lexical.ListItemNode,
  QuoteNode = _Lexical.QuoteNode,
  HeadingNode = _Lexical.HeadingNode;
const _svs$ui = svs.ui,
  ReactIconButton = _svs$ui.ReactIconButton,
  ReactIcon = _svs$ui.ReactIcon;
const RichTextState = svs.components.marketplaceRetailAdmin.richText.helpers.RichTextState;
const getLogger = svs.core.log.getLogger;
const logger = getLogger('marketplaceRetailAdmin:richText');
const _React = React,
  useState = _React.useState;
const lexicalViewerTheme = {
  paragraph: 'lexical-paragraph',
  quote: 'RichEditor-blockquote',
  text: {
    bold: 'lexical-bold',
    italic: 'lexical-italic',
    code: 'lexical-code'
  },
  list: {
    ul: 'lexical-ul',
    ol: 'lexical-ol',
    listitem: 'lexical-listitem'
  }
};
const ViewerEditor = _ref => {
  let richDescription = _ref.richDescription;
  const initialConfig = {
    namespace: 'Viewer',
    nodes: [ListNode, ListItemNode, QuoteNode, HeadingNode],
    editorState: richDescription instanceof RichTextState ? richDescription.getLexicalJson() : null,
    editable: false,
    onError: error => {
      logger.error('Lexical viewer error:', error);
    },
    theme: lexicalViewerTheme
  };
  return React.createElement(LexicalComposer, {
    initialConfig: initialConfig
  }, React.createElement(RichTextPlugin, {
    contentEditable: React.createElement(ContentEditable, {
      className: "lexical-content-editable"
    }),
    ErrorBoundary: LexicalErrorBoundary,
    placeholder: null
  }), React.createElement(ListPlugin, null));
};
const Viewer = _ref2 => {
  let richDescription = _ref2.richDescription,
    withExpander = _ref2.withExpander;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  const plainTextLength = richDescription && richDescription instanceof RichTextState ? richDescription.getPlainText().length : 0;
  if (!withExpander || plainTextLength <= 450) {
    return React.createElement(ViewerEditor, {
      richDescription: richDescription
    });
  }
  const onToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  return React.createElement("div", null, React.createElement("div", {
    className: "rich-text-viewer ".concat(isExpanded ? 'rich-text-viewer-expanded' : 'rich-text-viewer-compact')
  }, React.createElement(ViewerEditor, {
    richDescription: richDescription
  })), React.createElement(ReactIconButton, {
    className: "rich-text-viewer-expander-arrow qa-text-expander-arrow",
    onClick: onToggleExpand
  }, React.createElement("div", {
    style: {
      transition: 'transform .15s cubic-bezier(0.5, 1, 0.89, 1)',
      transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
    }
  }, React.createElement(ReactIcon, {
    icon: "menu-down",
    size: "200"
  }))));
};
Viewer.defaultProps = {
  richDescription: RichTextState.createEmpty(),
  withExpander: false
};
setGlobal('svs.components.marketplaceRetailAdmin.richText.Viewer', Viewer);

 })(window);